import * as types from './mutation-types'
import Cookies from 'js-cookie'

const saveToken = store => {
  store.subscribe((mutation, { token }) => {
    if (mutation.type === types.SET_TOKEN) {
      if (token) {
        Cookies.set('ata', token, {expires: 30})
      } else {
        Cookies.remove('ata')
      }
    }
  })
}

export default [saveToken]



// WEBPACK FOOTER //
// ./src/store/plugins.js